import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const anchorNavigationItemFn = /* @__PURE__ */ createRecipe('anchor-navigation-item', {
  "colors": "primary"
}, [])

const anchorNavigationItemVariantMap = {
  "color": [
    "danger"
  ]
}

const anchorNavigationItemVariantKeys = Object.keys(anchorNavigationItemVariantMap)

export const anchorNavigationItem = /* @__PURE__ */ Object.assign(memo(anchorNavigationItemFn.recipeFn), {
  __recipe__: true,
  __name__: 'anchorNavigationItem',
  __getCompoundVariantCss__: anchorNavigationItemFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: anchorNavigationItemVariantKeys,
  variantMap: anchorNavigationItemVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, anchorNavigationItemVariantKeys)
  },
  getVariantProps: anchorNavigationItemFn.getVariantProps,
})